import { createEntityAdapter } from "@reduxjs/toolkit";
import formInputsNormalizer from "../normalizers/formInputs";

const createCustomizedEntityAdapter = (_normalizer, options = {}) => {
  const _adapter = createEntityAdapter(options);
  const normalizer = (entity) => {
    return _normalizer(entity, {
      adapter: _adapter
    })
  };
  return {
    ..._adapter,
    // Override methods that add entities to normalize them first
    addOne: (state, entity) => {
      const normalized = normalizer(entity);
      if (normalized) {
        return _adapter.addOne(state, normalized);
      }
      return _adapter.addOne(state, entity);
    },
    addMany: (state, entities) => {
      const normalized = entities.map(normalizer).filter(Boolean);
      if (normalized.length) {
        return _adapter.addMany(state, normalized);
      }

      return _adapter.addMany(state, entities);
    },
    setAll: (state, entities) => {
      const normalized = entities.map(normalizer).filter(Boolean);
      if (normalized.length) {
        return _adapter.setAll(state, normalized);
      }

      return _adapter.setAll(state, entities);
    },
    upsertOne: (state, entity) => {
      const normalized = normalizer(entity);
      if (normalized.length) {
        return _adapter.upsertOne(state, normalized);
      }

      return _adapter.upsertOne(state, entity);
    },
    upsertMany: (state, entities) => {
      const normalized = entities.map(normalizer).filter(Boolean);
      if (normalized.length) {
        return _adapter.upsertMany(state, normalized);
      }
      return _adapter.upsertMany(state, entities);
    },
  };
};

export const createCustomizedEntityAdapterForForms = (options = {}) =>
  createCustomizedEntityAdapter(formInputsNormalizer, options);

export default createCustomizedEntityAdapter;
